import React from 'react';
import { Box } from '@mui/material';
import { Avatar } from './ui';

const UserQuestion = ({ username, naturalLanguageQuery }) => {
    return (
      <Box sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          width: '100%',
          p: 1,
          pr: 2,
      }}>
          <Box sx={{
              display: 'flex',
              alignItems: 'flex-end',
              gap: 1.5,
              maxWidth: { xs: '90%', sm: '75%' },
          }}>
              <Box sx={{
                  backgroundColor: '#E20000',
                  color: '#fff',
                  borderRadius: '18px 18px 4px 18px',
                  px: 2.5,
                  py: 1.5,
                  fontSize: '0.95rem',
                  lineHeight: 1.6,
              }}>
                  {naturalLanguageQuery}
              </Box>
              <Avatar size="md" text={username.charAt(0).toUpperCase()} />
          </Box>
      </Box>
    );
};

export default UserQuestion;
